import { ArrayCompositionPipeable } from '../base/pipeable/array_composition_pipeable.js';

class ReviewsPipeables {
  get overallRating() {
    if (!this.#overallRating) {
      this.#overallRating = new ArrayCompositionPipeable(
        this.#caster,
        () => this.#caster.overallRating,
        ['ratings'],
        `[Value:OverallRating]`
      );
    }
    return this.#overallRating;
  }

  get summary() {
    if (!this.#summary) {
      this.#summary = new ArrayCompositionPipeable(
        this.#caster,
        () => this.#caster.summary,
        ['ratings'],
        '[Value:Summary]'
      );
    }
    return this.#summary;
  }

  constructor(caster) {
    this.#caster = caster;
  }

  #caster;

  #overallRating;
  #summary;
}

export { ReviewsPipeables };
